import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AppIcon } from './app_icon';
import NotificationWrapper from '../vertical_icon_bar/notification_wrapper';
export const AppIconWithBadge = ({ notificationCount, ...props }) => {
    return (_jsx(NotificationWrapper, { count: notificationCount, children: _jsx(AppIcon, { ...props }) }));
};
//# sourceMappingURL=app_icon_with_badge.js.map